export const getSupplierList = (req)=>{
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // body: JSON.stringify(req)
    };
    return fetch('/shared/api/getSupplierDetails').then((response)=>response.json())
}